import { React, useEffect, useRef, useState } from 'react';
import { Container, Row, Modal, Toast, Offcanvas, OverlayTrigger, Tooltip } from 'react-bootstrap';
import './Home.css';
import api from '../seller-apis/api';
import EnquiryCard from './common/EnquiryCard';
import ProductCard from './common/ProductCard';
import servicesApi from '../seller-apis/servicesApi';
import Popup from './common/Popup';
import { pendingEnquiries, newOrders, approvedProducts, filterOrdersfilter, unverifiedPriceProducts, fetchOpportunityData, actionRequiredFilter, weightVerificationFilter, filterOrders } from '../seller-apis/apidataField';
import PaginationCom from './common/Pagination';
import ConfirmationModal from './common/ConfirmationModal';
import PopupEnquiry from './common/PopupEnquiry';
import UpdtProPopup2 from './common/UpdtProPopup2';
import OrderCardWeb from './common/OrderCardWeb';
import '../assets/css/modal.css'
import { NavLink } from 'react-router-dom';
import { variables } from '../Variables.json'
import { useAlert } from 'react-alert';
import ProfileStepsTab from './profile/ProfileStepsTabs';
import { useDispatch, useSelector } from 'react-redux';
import { Actions } from '../Actions/Actions';
import store from '../Store';
import { loadSellerMeIfNeeded } from '../Actions/bootstrapSellerMe';
import CompetitivenessBox from './common/CompetitivenessBox';
import boostSalesImg from '../assets/images/boost-sales.gif';
import opImg1 from '../assets/images/home-newopp-1.png';
import opImg2 from '../assets/images/home-newopp-2.png';
import opImg3 from '../assets/images/home-newopp-3.png';
import opImg4 from '../assets/images/home-newopp-4.png';
import competitiveImg1 from '../assets/images/home-competitve-1.png';
import competitiveImg2 from '../assets/images/home-competitve-2.png';
import competitiveImg3 from '../assets/images/home-competitve-3.png';
import NoticePopup from './NoticePopup/NoticePopup';
import { timeAgo } from '../utilities/ConvertDateFormat';
import AdjustPriceModal from './common/OrderLost/AdjustPriceModal';
import { useNotification } from './common/OrderLost/NotificationContext';
import moment from 'moment';
import { saveVendorStock } from '../services/vendor.service';

function Home() {

  const {PendingQuestionCount,LeadCount} = useSelector(state => state.ActionReducer);
  const vendorName = localStorage.getItem("name")
  const alert = useAlert()
  // Screen states
  const dispatch = useDispatch();
  const [currView, setcurrView] = useState();

  // Setting response States


  const [enquiries, setEnquiries] = useState([]);
  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [sEnquiry, setsEnquiry] = useState(0);
  const [noenquiry, setnoenquiry] = useState(0);
  const [noOrder, setnoOrder] = useState(0);
  const [noPickOrder, setnoPickOrder] = useState(0);
  const [loaderState, setloaderState] = useState("flex");
  const [isPopupVisible, setisPopupVisible] = useState("none");
  const [enqloaderState, setenqloaderState] = useState("none");
  const [isProductPopupVisible, setisProductPopupVisible] = useState("none")
  const [productNo, setproductNo] = useState(0);
  const [profileData, setProfileData] = useState(null);
  const reduxGrabOrderCount = useSelector(state => state.ActionReducer.grabOrderCount);
  const [todayLeadsCount, setTodayLeadsCount] = useState(0);
  const [supportTicketsCount, setSupportTicketsCount] = useState(0);
  const [verifyPriceCount, setVerifyPriceCount] = useState(0);
  const [verifyWeightCount, setVerifyWeightCount] = useState(0);

  // Toast

  const [showToast, setshowToast] = useState(false)
  const [ToastMsg, setToastMsg] = useState();

  // Loader state

  const [loaderProduct, setloaderProduct] = useState("none")
  const [loaderOrder, setloaderOrder] = useState("none");


  // Popup related states
  const [selectedImgPopup, setselectedImgPopup] = useState();
  const [updtProVisibility, setupdtProVisibility] = useState(false);
  const [clickedUpdateNo, setCickedUpdateNo] = useState();
  const [selectedProductPopup, setselectedProductPopup] = useState();
  const [popupData, setpopupData] = useState();
  const [showPopup, setshowPopup] = useState(false);
  const [popuprecordreceived, setpopuprecordreceived] = useState(false)
  const [isPopupTrackNewVisible, setisPopupTrackNewVisible] = useState("block");
  const [updtPopuprel, setupdtPopuprel] = useState([]);
  const [detailOrdPrice, setdetailOrdPrice] = useState("");
  const [noticeModalState, setNoticeModalState] = useState(true);

  // Confirmation Related States

  const [confirmationState, setconfirmationState] = useState(false)
  const [msgConfirmation, setmsgConfirmation] = useState();
  const [selectedProduct, setselectedProduct] = useState();
  const [confirmationStateEnquiry, setconfirmationStateEnquiry] = useState(false);
  const [selectedId, setselectedId] = useState();
  const [activDeactiveState, setactivDeactiveState] = useState();
  const [enquiryTo, setenquiryTo] = useState();
  const [selectedenquiry, setselectedenquiry] = useState();
  const [confirmationType, setconfirmationType] = useState();
  const [deactiveReason, setdeactiveReason] = useState(false)
  const [activeRec, setActiveRec] = useState("")


  // Pagination related

  const [selectedPage, setselectedPage] = useState(1);

  const [selpgenq, setselpgenq] = useState(1);
  const [selpgord, setselpgord] = useState(1);
  const [selpgpro, setselpgpro] = useState(1);
  // Get the date before 15 days
  var currentDate = new Date();
  var before15Days = new Date();
  var before30Days = new Date();
  before15Days.setDate(currentDate.getDate() - 15);
  before30Days.setDate(currentDate.getDate() - 30);

  // Format the dates as strings (optional)
  var currentDateStr = currentDate.toISOString().split('T')[0];
  var before15DaysStr = before15Days.toISOString().split('T')[0];
  var before30DaysStr = before30Days.toISOString().split('T')[0];

  // Seller details

  const [sellerDetail, setsellerDetails] = useState("");


  // Track order Popup
  const [selectedtrackOrderNew, setselectedtrackOrderNew] = useState(0);
  const [selectedTrackwithinNew, setsetselectedTrackwithinNew] = useState(0);


  // Combination related

  const [combAttri, setcombAttri] = useState([]);
  const [currentProupdt, setcurrentProupdt] = useState();


  // Order popup related


  const [productDetail, setproductDetail] = useState([
    {
      "description": "No details available",
      "sdescription": "No short description",
      "name": undefined,
      "price": undefined,
      "SKU": undefined,
      "popupVisibility": undefined,
      "images": []
    }
  ]);
  const [isDetailPopupVis, setisDetailPopupVis] = useState("block");
  const [defUrl, setdefUrl] = useState();



  // GST TAN rejected related

  const [isgsttanreject, setisgsttanreject] = useState(false);
  const [gsttanpopup, setgsttanpopup] = useState(false);
  const [verifiedSeller, setVerifiedSeller] = useState(false);
  const [agreementpopup, setagreementpopup] = useState(false);

  //SL-719
  const [productOppCount, setProductOppCount] = useState("")
  const [restockOppCount, setRestockOppCount] = useState("")
  const [pricingOppCount, setPricingOppCount] = useState("")

  // SL-988
  const [recentOrders, setRecentOrders] = useState([])
  const [recenOrdersCat, setRecentOrderCat] = useState({
    lostOrders: 0,
    newOrders: 0
  });

  const [isOpenAdjPrModal, setIsOpenAdjPrModal] = useState(false)
  const [orderLostCurrentData, setOrderLostCurrentData] = useState(null)

  // Mised opportunity (SL-1091)
  const [missedOpportunities, setMissedOpportunities] = useState([]);

  // Add to Stock Modal
  const [isAddStockModalOpen, setIsAddStockModalOpen] = useState(false);
  const [addStockValue, setAddStockValue] = useState('');
  const [selectedMissedOpp, setSelectedMissedOpp] = useState(null);

  const { notifications, notificationQueue } = useNotification();
  const prevCountRef = useRef(0);

  const { addGrabOrderNotification } = useNotification();

  // SL-1080 
  // useEffect(() => {
  //   const currentCount = notifications.length + notificationQueue.length;
  //   if (currentCount > prevCountRef.current) {
  //     handleRecentOrdersCall()
  //   }

  //   prevCountRef.current = currentCount;
  // }, [notifications, notificationQueue]);

    useEffect(() => {
    if (!localStorage.getItem('token') || localStorage.getItem('token') === 'undefined') {
      window.location.assign('/')
      return;
    }

    const run = async () => {
      try {
        await loadSellerMeIfNeeded(dispatch);
        const res = {
          data: store.getState().vendorDetailsReducer.sellerMeData,
          message: store.getState().vendorDetailsReducer.sellerMeMessage,
        };
        if (!res.data) return;
          console.log(res);
          setProfileData(res.data);
          if (res.message === "Seller Not Activated") {
            setVerifiedSeller(false);
            Actions.SellerVerified(dispatch, false);
          }
          else {
            setVerifiedSeller(true);
          }
          setsellerDetails(res.data)
          if ((res?.data?.gstVerified && res?.data?.gstVerified?.status === "REJECTED") || (res?.data?.panVerified && res?.data?.panVerified?.status === "REJECTED") || (res?.data?.agreementVerified && res?.data?.agreementVerified?.status === "REJECTED") || (res?.data?.msmeVerified && res?.data?.msmeVerified?.status === "REJECTED") || (res?.data?.tanVerified && res?.data?.tanVerified?.status === "REJECTED")) {
            setisgsttanreject(true)
            setgsttanpopup(true)
          }
          let filterData = {
            "pageNo": "1",
            "size": 1
          }
              // Pending Enquiries
              let filterEnquiry = {
                pageNo: "1",
                size: 1,
                dates: {
                  "from-createdAt": before15DaysStr + 'T00:00:00',
                  "to-createdAt": currentDateStr + 'T23:59:59'
                },
              };
              api.order.orders(pendingEnquiries(filterEnquiry)).then((res) => {
                setnoenquiry(res.totalRecords)
                setEnquiries(res.data)
                setloaderState("none")
              }).catch((err) => {
                console.log(err)
                setloaderState("none")
              })


              // Pending Orders

              fetchNewOrders()
              // SL-1217
              fetchPickupPending();
              // api.order.orders(filterOrdersfilter(filterData, ["DOWNLOAD"])).then((res) => {
              //   // console.log(res)
              //   setnoPickOrder(res.totalRecords)
              // }).catch(err => console.log(err))

              // Opportunities
              // sl - 719
              // pricing opp.
              let pricingOppData = {
                pageNo: 1,
                size: 1,
                filters: {
                }
              }
              api.Opportunity.fetchPriceOpportunity(fetchOpportunityData(pricingOppData)).then(res => {
                setPricingOppCount(res.totalRecords);
              });

              // grab order 
              let grabOrderFilterData = {
                pageNo: 1,
                size: 1,
                filters: {
                  "status": "pending",
                  "orderType": 'grab_order'
                },
                sortFilter: { "createdAt": -1 },
              };

              api.Opportunity.fetchOpportunity(fetchOpportunityData(grabOrderFilterData)).then(res => {
                Actions.GrabOrderCountAction(dispatch, res.totalRecords);
              });

             

              // Leads today
              const now = new Date();
              const tzOffsetMs = now.getTimezoneOffset() * 60 * 1000;
              const startOfDayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
              const endOfDayLocal = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
              const startOfDayUTC = new Date(startOfDayLocal.getTime() - tzOffsetMs).toISOString();
              const endOfDayUTC = new Date(endOfDayLocal.getTime() - tzOffsetMs).toISOString();
              var leadFilterData = {
                pageNo: 1,
                size: 1,
                filter: {
                  "from-createdAt": startOfDayUTC,
                  "to-createdAt": endOfDayUTC,
                },
              };
              api.customerLeads.getLeads(leadFilterData).then((res) => {
                setTodayLeadsCount(res?.data?.totalRecords || 0);
              });

              // Support Tickets New
              // SL-1172
              // const supportFilterData = {
              //   "pageNo": 1,
              //   "size": 1,
              //   "filter": {
              //     "adminMsgInfo.vendorViewed": false,
              //     "status.label": { $ne: "Resolved" },
              //     "from-createdAt": before30DaysStr + 'T00:00:00',
              //     "to-createdAt": currentDateStr + 'T23:59:59'
              //   },
              //   "sortFilter": {
              //     "createdAt": -1
              //   }
              // }
              // api.supportTicket.getSupportTicket(supportFilterData).then(res => {
              //   setSupportTicketsCount(res.totalRecords);
              // });

              // SL-1086
              // Verify Prices
              let verifyPriceFilter = {
                pageNo: 1,
                size:1,
                prStatus: {
                  $or: [
                    {
                      $and: [
                        //{ combination: { $exists: false, $size: 0  } },
                        {
                          $or: [
                            { combination: { $exists: false } },
                            { combination: { $size: 0 } }
                          ]
                        },
                        { prSts: "V_PENDING" }
                      ]
                    },
                    {
                      combination: {
                        $elemMatch: {
                          purchase_price: { $exists: true, $ne: null },
                          prSts: "V_PENDING"
                        }
                      }
                    },
                  ],
                },
              };
              api.product.productsRetrieveall(actionRequiredFilter(verifyPriceFilter))
              .then((res) => {
                setVerifyPriceCount(res?.totalRecords);
              }).catch(err => console.log(err)) 

              let verifyWeightFilter = {
                "pageNo": 1,
                "size":1,
                //No need to show products in which vendor's active == false | Ticket : SL-968
                // "status": {
                //     "active": false
                // },
                weightStatus: {
                  $or: [
                    {
                      //SL-968
                      $and: [
                        {
                          $or: [
                            { combination: { $exists: false } },
                            { combination: { $size: 0 } }
                          ]
                        },
                        { sellerWeightChangeSts: "V_PENDING" }
                      ]
                    },
                    {
                      combination: {
                        $elemMatch: {
                          purchase_price: { $exists: true, $ne: null },
                          sellerWeightChangeSts: "V_PENDING"
                        }
                      }
                      /*$and : [
                      { combination: { $exists: true, $ne: [] } },
                      { "combination.purchase_price" : { $exists: true, $ne: null }},
                      { "combination.sellerWeightChangeSts": "V_PENDING" },
                      ]*/
                    },
                  ],
                }
              }
              api.product.productsRetrieveall(weightVerificationFilter(verifyWeightFilter)).then((res) => {
                setVerifyWeightCount(res?.totalRecords)
              }).catch(err => console.log(err))
              handleRecentOrdersCall()
              handleMissedOpportunitiesCall()
         } catch (err) {
        console.log(err);
      }
    };
    run();
  }, [dispatch])

  const fetchNewOrders = () => {
    let dateFromWeb = moment().subtract(30, 'days').format('YYYY-MM-DD');
    let dateToWeb = moment().format('YYYY-MM-DD');
    let orderFilter = {
      "pageNo": 1,
      "size": 1,
      "statusFilter": ["ASSIGN"],
      "dates": {

      }
    }
    orderFilter.dates = {
      "from-createdAt": dateFromWeb + 'T00:00:00',
      "to-createdAt": dateToWeb + 'T23:59:59'
    }
     api.order?.orders(filterOrders(orderFilter)).then((res) => {
      setnoOrder(res.totalRecords)
      Actions.OrderCountAction(dispatch, { newOrders: res.totalRecords });
    }).catch(err => {
      console.log(err)
    })
  }
  
  // SL-1217
  const fetchPickupPending = () => {
    let dateFromWeb = moment().subtract(30, 'days').format('YYYY-MM-DD');
    let dateToWeb = moment().format('YYYY-MM-DD');
    let orderFilter = {
      "pageNo": 1,
      "size": 1,
      "statusFilter": ["DOWNLOAD"],
      "dates": {

      }
    }
    orderFilter.dates = {
      "from-createdAt": dateFromWeb + 'T00:00:00',
      "to-createdAt": dateToWeb + 'T23:59:59'
    }
    api.order.orders(filterOrders(orderFilter)).then((res) => {
      setnoPickOrder(res.totalRecords)
    }).catch(err => console.log(err))
  }

  const handleRecentOrdersCall = () => {
    api.order.getVendorRecentOrders({
      size: 15,
      filter: {}
    })
      .then((res) => {
        setRecentOrders(res?.data);

        let lostOrders = 0;
        let newOrders = 0;
        res?.data?.forEach((item) => {
          if (item?.orderType === "LOST_ORDER") lostOrders++;
          if (item?.orderType === "NEW_ORDER") newOrders++;
        });

        setRecentOrderCat({
          lostOrders: lostOrders,
          newOrders: newOrders,
        });
      })
      .catch(err => {
        console.log(err);
      });
  };

  const handleMissedOpportunitiesCall = async() => {
    try{
      const res = await api.Opportunity.getMissedOpportunity({});
      setMissedOpportunities(res?.data);
    }catch(err){
      console.log(err)
    }
  }


  function paginate(data) {
    setproductNo(0);
    setselectedPage(data.number)
    let outerdiv = document.getElementById("outer");
    let filter = {
      "pageNo": data.number
    }

    // Pending Enquiries

    if (data.comp === "Newenquiry") {

      let loaderEnq = document.getElementById("enenqoader");
      setselpgenq(data.number)
      setenqloaderState("block")
      loaderEnq.classList.add("loader-bt");
      outerdiv.classList.add("div-bk");
      setEnquiries([])
      let filterEnquiry = {
        pageNo: "1",
        dates: {
          "from-createdAt": before15DaysStr + 'T00:00:00',
          "to-createdAt": currentDateStr + 'T23:59:59'
        },
      };
      api.order.orders(pendingEnquiries(filterEnquiry)).then((res) => {
        setnoenquiry(res.totalRecords)
        setEnquiries(res.data)
        setenqloaderState("none")
        loaderEnq.classList.remove("loader-bt");
        outerdiv.classList.remove("div-bk");
      }).catch((err) => {
        console.log(err)
        setenqloaderState("none")
        loaderEnq.classList.remove("loader-bt");
        outerdiv.classList.remove("div-bk");
      })
    }


    // Pending Orders

    else if (data.comp === "Pendingorders") {
      setselpgord(data.number)
      setloaderOrder("block")
      let loaderOrd = document.getElementById("enOrderLoader");
      loaderOrd.classList.add("loader-bt");
      outerdiv.classList.add("div-bk");
      api.order.orders(filterOrdersfilter(filter, ['ASSIGN'])).then((res) => {
        setnoOrder(res.totalRecords)
        setOrders(res.data)
        setloaderOrder("none");
        loaderOrd.classList.remove("loader-bt");
        outerdiv.classList.remove("div-bk");
      }).catch(err => {
        console.log(err)
        setloaderOrder("none");
        loaderOrd.classList.remove("loader-bt");
        outerdiv.classList.remove("div-bk");
      })
    }

    // Products

    else if (data.comp === "appProducts") {
      let loaderDiv = document.getElementById("enNewLoader")
      setselpgpro(data.number)
      setloaderProduct("block");
      loaderDiv.classList.add("loader-bt");
      outerdiv.classList.add("div-bk");
      api.product.productsRetrieveall(approvedProducts(filter)).then((res) => {
        setProducts(res.products)
        outerdiv.classList.remove("div-bk");
        loaderDiv.classList.remove("loader-bt");
        setloaderProduct("none")

      }).catch(err => {
        console.log(err)
        outerdiv.classList.remove("div-bk");
        loaderDiv.classList.remove("loader-bt");
        setloaderProduct("none")
      })
    }
  }


  //  Control view acc to size
  function handleResize() {
    if (window.outerWidth > 700) {
      setcurrView('desktop');
    }
    else {
      setcurrView('mobile');
    }

  }

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  // Popup showing detail


  function detail(data, price) {
    setdetailOrdPrice(price)
    if (data && data[0] === undefined) {
      setproductDetail(
        [
          {
            "description": "No details available",
            "sdescription": "No short description",
            "name": undefined,
            "price": undefined,
            "SKU": undefined,
            "popupVisibility": undefined,
            "images": []
          }
        ]
      )
    }
    else {
      setproductDetail(data)
    }
  }


  // Update enquiries

  function approveEnquiry(e) {
    setenquiryTo("approve")
    setselectedenquiry(e)
    setmsgConfirmation("Are you sure you want to approve this product?")
    setconfirmationStateEnquiry(true)
  }


  function disapproveEnquiry(e) {
    setenquiryTo("disapprove")
    setselectedenquiry(e)
    setmsgConfirmation("Are you sure you want to disapprove this product?")
    setconfirmationStateEnquiry(true)
  }

  //   Popup related functions

  function setpopupVisibility(e, popupInfo) {
    if (e === "2") {

      setpopupData(popupInfo)
      setshowPopup(true)
      setpopuprecordreceived(true)

    }
    else {
      setshowPopup(false)
    }
  }


  function setproductpopupVisibility(e) {
    if (e > -1) {
      setproductNo(e)
      setisProductPopupVisible("block")
    }
    else {
      setisProductPopupVisible("none")
    }
  }






  // Order Picked


  function productPicked(id, status, pname) {
    setconfirmationType("orders")
    if (status === "ASSIGN") {
      setToastMsg("Please download manifest to proceed with pickup.")
      setshowToast(true)
    }
    else if (status === "DOWNLOAD") {
      setselectedProduct(pname)
      setselectedId(id)
      setmsgConfirmation("Is product picked up by courier boy?")
      setconfirmationState(true)
    }
  }



  // Manifest Download Confirmation

  function isManifestDownloaded(res) {
    if (res === "yes") {
      let filterData = {
        "pageNo": "1"
      }
      setTimeout(() => {
        api.order.orders(filterOrdersfilter(filterData, ['ASSIGN'])).then((res) => {

          setOrders(res.data)
          setnoOrder(res.totalRecords)
        }).catch(err => {
          console.log(err)
        })
      }, 500);
    }
  }

  function trackPopupfunNew(e, trackNo, docketNo) {
    setselectedtrackOrderNew(e)
    setsetselectedTrackwithinNew(trackNo)
  }

  function setpopupVisibilityNewTrack(e) {
    if (e) {
      setisPopupTrackNewVisible("block")
    }
    else {
      setisPopupTrackNewVisible("none")
    }
  }



  // Product related
  function productCheck(e) {
    setcombAttri([]);
    for (let i = 0; i < products.length; i++) {
      let baseImg;
      if (products[i]._id === e) {
        setselectedProductPopup(products[i].productName)
        if (products[i].attributeList) {
          if (products[i].attributeList.length > 0) {
            setcombAttri(products[i].attributeList)
            setcurrentProupdt(products[i])
          }
        }
        setupdtPopuprel({
          "SKU": products[i].SKU,
          "price": products[i].vendors[0].purchase_price
        })
        products[i].images.map((item) => {
          if (item.baseImage === true) {
            if (item.image.startsWith("products")) {
              baseImg = item.image;
              setselectedImgPopup(baseImg)
            }
            else {
              let img = item.image.substr("41")
              baseImg = img;
              setselectedImgPopup(baseImg)
            }
          }
        })
      }
    }

    setCickedUpdateNo(e)
    setupdtProVisibility(true)
  }

  function checkpopupvisibility(e) {
    if (e === false) {
      setupdtProVisibility(false)
    }
    else {
      setupdtProVisibility(true)
    }
  }


  function henfun(e) {
    setproductNo(0)

    setproductNo(e)
  }




  // Update response

  function callbackResUpdate(res) {
    if (res === "product updated") {
      let filterData = {
        "pageNo": selectedPage
      }
      api.product.productsRetrieveall(approvedProducts(filterData))
        .then((res) => {
          setProducts(res.products)
        })
        .catch(err => {
          console.log(err)
        })
      alert.success("Product updated")
      setupdtProVisibility(false)
    }
    else {
      alert.error("Failed to update")
      setupdtProVisibility(false)
    }
  }

  // Confirmation Modal
  function confirmationBoxHiding(state) {
    if (state === false) {
      setconfirmationState(false)
    }
  }


  // Confirmation enquiry related

  function confirmationBoxHidingEnquiry(state) {
    if (state === false) {
      setconfirmationStateEnquiry(false)
    }
  }

  // Toggle

  function changeproductStatus(id, status) {
    let quantity;
    for (let i = 0; i < products.length; i++) {
      if (products[i]._id === id) {
        setselectedProduct(products[i].productName)
        quantity = products[i].vendors[0].stock;
      }
    }
    if (status === "on") {
      setdeactiveReason(false)
      // if (quantity === 0) {
      //   setToastMsg("Please update stock to activate product.");
      //   setshowToast(true)
      // } else {
      setactivDeactiveState("activate")
      setselectedId(id)
      setmsgConfirmation("Are you sure you want to activate this product")
      setconfirmationState(true)
      // }
    }
    else if (status === "off") {
      setdeactiveReason(true)
      setactivDeactiveState("deactivate")
      setselectedId(id)
      setmsgConfirmation("Are you sure you want to deactivate this product")
      setconfirmationState(true)
    }

  }

  // Confirmation Response

  function responseConfirmationEnquiry(ans, id) {
    // Enquiry

    if (enquiryTo === "approve") {
      if (ans === "yes") {
        let filterEnquiry = {
          pageNo: "1",
          dates: {
            "from-createdAt": before15DaysStr + 'T00:00:00',
            "to-createdAt": currentDateStr + 'T23:59:59'
          },
        };
        let data = {
          "_id": id,
          "status": "APPROVED"
        }
        api.order.updateOrder(data)
          .then((res) => {

            if (res.message === "record updated") {
              alert.success("Record updated")
              setTimeout(() => {
                api.order.orders(pendingEnquiries(filterEnquiry))
                  .then((res) => {
                    setEnquiries(res.data)
                    setnoenquiry(res.totalRecords)
                    setconfirmationStateEnquiry(false)
                  }).catch(err => {
                    console.log(err)
                  })
              }, 500);
            }
          }).catch(err => console.log(err))
      }
    } else if (enquiryTo === "disapprove") {
      if (ans === "yes") {

        let filterEnquiry = {
          pageNo: "1",
          dates: {
            "from-createdAt": before15DaysStr + 'T00:00:00',
            "to-createdAt": currentDateStr + 'T23:59:59'
          },
        };
        let data = {
          "_id": id,
          "status": "DISAPPROVED"
        }
        api.order.updateOrder(data)
          .then((res) => {

            if (res.message === "record updated") {
              alert.success("Record updated")
              setTimeout(() => {
                api.order.orders(pendingEnquiries(filterEnquiry))
                  .then((res) => {

                    setEnquiries(res.data)
                    setnoenquiry(res.totalRecords)
                    setconfirmationStateEnquiry(false)
                  }).catch(err => {
                    console.log(err)
                  })
              }, 500);
            }
          }).catch(err => console.log(err))
      }
    }
  }



  // Response Confirmation

  function responseconfirmation(ans, productId) {
    if (confirmationType === "orders") {
      let data = {
        "_id": productId,
        "status": "PICKED"
      }
      if (ans === "yes") {
        setconfirmationState(false)
        api.order.updateOrder(data).then((res) => {
          let filterData = {
            "pageNo": selectedPage,
          }
          alert.success("Order status updated")
          setTimeout(() => {
            api.order.orders(newOrders(filterData)).then((res) => {
              setOrders(res.data)
              setnoOrder(res.totalRecords)
            }).catch(err => {
              console.log(err)
            })
          }, 500);
        }).catch((err) => {
          alert.error("Failed")
          console.log(err)
        })
      }
    }
    else {
      //  Product
      if (ans === "yes") {
        if (activDeactiveState === "activate") {
          let data = {
            "_id": productId,
            "vActive": true
          }
          api.product.addToExProduct(data).then((res) => {
            let filter = {
              "pageNo": selectedPage
            }
            setconfirmationState(false)
            api.product.productsRetrieveall(approvedProducts(filter))
              .then((res) => {
                setProducts(res.products)
              })
              .catch(err => console.log(err))
            alert.success("Product status updated")
          }).catch((err) => {
            console.log(err)
          })
        }
        else if (activDeactiveState === "deactivate") {
          let data = {
            "_id": productId,
            "vActive": false
          }
          api.product.addToExProduct(data).then((res) => {
            let filter = {
              "pageNo": selectedPage
            }
            setconfirmationState(false)
            api.product.productsRetrieveall(approvedProducts(filter))
              .then((res) => {
                setProducts(res.products)
              })
              .catch(err => console.log(err))
            alert.success("Product status updated")
          }).catch((err) => {
            console.log(err)
          })
        }
      }
    }
  }


  // Orders popup related

  function setpopupVisibilityDetail(e) {
    if (e) {
      setisDetailPopupVis("block")
    }
    else {
      setisDetailPopupVis("none")
    }
  }


  // Set tab active

  function sethometabActive(e) {
    let btns = document.getElementsByClassName("tabLabel");
    for (let i = 0; i < btns.length; i++) {
      if (btns[i].id === e) {
        btns[i].classList.remove("home-tab-Btn-Active")
        btns[i].classList.add("home-tab-Btn-Active")
      }

      else if (btns[i].className === "tab1 tabLabel tab-home1 home-tab-Btn-Active") {
        btns[i].classList.remove("home-tab-Btn-Active")
      }

    }
  }

  const getStepobject = (data) => {
    let compArray = profileData?.profileStepsCompleted || [];

    for (var i = 0, iLen = compArray.length; i < iLen; i++) {

      if (compArray[i].name == data) {
        return compArray[i].value;
      }
      // return false;
    }
  }


  const onClosedAdjPrModal = (data, markAsRead) => {
    if (markAsRead && data?._id && data._id !== '') {
      api.order.markLostVendorMessagesAsRead(data._id).then((res) => {
      }).catch(err => {
        console.error('Mark as read error:', err)
      })
    }
    handleRecentOrdersCall()
    setIsOpenAdjPrModal(false)
    setOrderLostCurrentData(null);
  }

  const handleAdjustLostOrderClick = (item) => {
    let foundCmb;
    let combinationArray = item?.product?.productId?.combination;
    if (combinationArray && combinationArray?.length > 0) {
      foundCmb = combinationArray.find((cmb) => cmb?.SKU === item?.product?.SKU)
    }
    let data = {
      winningPrice: item?.selectedVendor?.purchasePrice,
      product_id: item?.product?.productId?._id,
      attributes: item?.product?.productId?.combination?.[0],
      image: item?.product?.productImage,
      productName: item?.product?.productName,
      SKU: item?.product?.SKU,
      vendorPrice: item?.lostVendorDetails?.purchasePrice,
      lowestPrice: item?.lowestPrice,
      foundCombination: foundCmb,
      currentVendorPurchasePrice: item?.lostVendorDetails?.currentVendorPurchasePrice,
      _id: item?._id
    }
    setOrderLostCurrentData(data)
    setIsOpenAdjPrModal(true)
  }

  const renderCombination = (notification) => {
    let foundCmb;
    let combinationArray = notification?.product?.productId?.combination;
    if (combinationArray && combinationArray?.length > 0) {
      foundCmb = combinationArray.find((cmb) => cmb?.SKU === notification?.product?.SKU)
    }
    if (foundCmb) {
      let attributeList = notification?.product?.productId?.attributeList;
      const comb = foundCmb;
      const pairs = attributeList?.map((item, index) => `${item?.attribute?.name} - ${comb?.value?.[index]}`);
      return `(${pairs.join(', ')})`;
    }
    return '';
  }

  // SL-1091
  const handleStockAddForMissedOpp = async () => {
    const qty = Number(addStockValue);

    if (
      Number.isInteger(qty) &&
      qty > 0
    ) {
      try {
        let data;
        let foundCmb = null;
        let productId = selectedMissedOpp?.product?.productId?._id
        let combinationArray = selectedMissedOpp?.product?.productId?.combination;
        if (combinationArray && combinationArray?.length > 0) {
          foundCmb = combinationArray.find((cmb) => cmb?.SKU === selectedMissedOpp?.product?.SKU)
        }
        if (foundCmb && foundCmb?.url) {
          let chCom = {
            "url": foundCmb.url,
            "stock": qty,
            "vActive": "ACTIVE"
          }
          data = {
            "_id": productId,
            "combination": chCom
          }
        }
        else {
          data = {
            "_id": productId,
            "stock": qty,
            "vActive": "ACTIVE"
          }
        }
        let saveVendorStockRes = await handleSaveVendorStock(foundCmb,qty);
        let res = await api.product.addToExProduct(data);
        alert.success('Stock added successfully');
        setIsAddStockModalOpen(false);
        setAddStockValue('');
        handleMissedOpportunitiesCall();
      } catch (err) {
        console.log(err)
      }
    } else {
      alert.error('Please enter a valid quantity');
    }

  }

    // SL-1092
    const handleSaveVendorStock = async (foundCmb, qty) => {
      try {
        let data = {
          "product": selectedMissedOpp?.product?.productId?._id,
          "vendor": selectedMissedOpp?.lostVendorDetails?.vendorId,
          "taxClass": selectedMissedOpp?.product?.taxClass,
          "purchase_price": selectedMissedOpp?.lostVendorDetails?.curPurchasePrice,
          "stock": qty,
          "status": "AUTOAPPROVED",
          "stockStatus": "In Stock",
          // "site_price": selectedMissedOpp?.product?.site_price,
          // "categories": selectedMissedOpp?.product?.productId?.categories,
          "receivedFrom":"Restock Opp"
        }
        if(foundCmb && foundCmb?.url){
          data.combination = {
            "url": foundCmb.url
          }
        }
        const res = await saveVendorStock(data)
      } catch (err) {
        console.log(err)
        alert.error(err.message || "Failed to update stock status");
        // Re-throw the error so the calling function knows it failed
        throw err;
      }
    }

    return (
      <>
        <div id="outer">

          <div className="p-0 page-bg pr" >

            {profileData && !profileData?.active && <div className='home-step bb-2'>
              {(getStepobject('step1') && getStepobject('step2') && getStepobject('step3')) ? <div className='incomplete-msg' style={{ color: '#F18805' }}>Profile Verification pending</div> :
                <div className='incomplete-msg'>Profile Incomplete !
                  <NavLink to="/profile"><button className='completenow-but'>Complete Now</button></NavLink>
                </div>}
              <div className='w-100'>
                <ProfileStepsTab profile={profileData} />
              </div>
            </div>}
            <section>

              {/* <Container > */}
              {/* Notification Box */}
              {isgsttanreject ? <div>
                <NavLink className='text-danger' exact to="/profile"> Uploaded KYC is Invalid. Please reverify !</NavLink>
              </div> : <></>}

              <Row className={`home-inner-container align-items-stretch  ${!verifiedSeller ? 'grayscale' : ''}`}>
                {/* sl - 719 */}

                <div className='col-12'>
                  {/* CompetitivenessBox  */}
                  <div style={{ display: "flex", flexDirection: "row", flex: 1, margin: "0px 5px 0px 0px" }}>
                    {reduxGrabOrderCount > 0 && <CompetitivenessBox title="Grab Orders" icon="bi bi-graph-up-arrow" percent={reduxGrabOrderCount} bgColor='#6ED66B' bottomComment="Losing order to competitors due to high prices" comp="home" to="/my-order/graborder" />}
                    <CompetitivenessBox title="Pickup Pending" icon="bi bi-cart3" percent={noPickOrder} bgColor='#FFCD31' bottomComment="Losing order to competitors due to high prices" comp="home" to="/my-order/processed" />
                    <CompetitivenessBox title="Leads Today" icon="bi bi-eye" percent={todayLeadsCount} bgColor='#FC0707' bottomComment="Losing order to competitors due to high prices" comp="home" to="/customer-leads/details" />
                    <CompetitivenessBox title="New Orders" icon="bi bi-box-seam" percent={noOrder} bgColor='#FC0707' bottomComment="Losing order to competitors due to high prices" comp="home" to="/my-order/unprocessed" />
                  </div>
                  {/* CompetitivenessBox ends */}
                  <Row className='align-items-stretch justify-content-around' style={{ marginTop: "11px" }}>
                    {/* Priority Actions */}
                    <div className="w-30 home-shadow-box" >
                      <div className="section-title">
                        <i className="bi bi-exclamation-triangle" style={{ color: "yellowgreen", fontSize: "19px" }}></i>
                        Priority Actions
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px", background: "#F0FFF0" }}>
                        <NavLink to={verifiedSeller ? "/my-inventory/approved/actionrequired" : "#"}>
                          <div className="box">
                            <div className="icon-img"><i className="bi bi-exclamation-triangle"></i></div>
                            <div className="title">
                              <div className="name">Verify Prices</div>
                            </div>
                            <div className="count">{verifyPriceCount}</div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink>
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px", background: "#FFFFE0" }}>
                        <NavLink to={verifiedSeller ? "my-inventory/approved/weightverification" : "#"}>
                          <div className="box">
                            <div className="icon-img"><i className="bi bi-diagram-2-fill"></i></div>
                            <div className="title">
                              <div className="name">Verify Weights</div>
                            </div>
                            <div className="count">{verifyWeightCount}</div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink>
                      </div>
                      {
                        reduxGrabOrderCount > 0 &&
                        <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px", background: "#FFE4E1" }}>
                          <NavLink to={verifiedSeller ? "/my-order/graborder" : "#"}>
                            <div className="box">
                              <div className="icon-img"><i className="bi bi-cart"></i></div>
                              <div className="title">
                                <div className="name">Grab New Orders</div>
                              </div>
                              <div className="count">{reduxGrabOrderCount}</div>
                              <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                            </div>
                          </NavLink>
                        </div>
                      }
                    </div>
                    {/* Priority Actions*/}

                    {/* Customer Engagement Section */}
                    <div className="w-30 home-shadow-box" >
                      <div className="section-title">
                        <i className="bi bi-people" style={{ color: "dodgerblue", fontSize: "19px" }}></i>
                        Customer Engagement
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px", background: "#F0FFF0" }}>
                        <NavLink to={verifiedSeller ? "/support" : "#"}>
                          <div className="box">
                            <div className="icon-img"><i className="bi bi-chat-left"></i></div>
                            <div className="title">
                              <div className="name">Support Tickets</div>
                            </div>
                            {/* <div className="count">{supportTicketsCount}</div> */}
                             <div className="count"></div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink>
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px", background: "#F0F8FF" }}>
                        <NavLink to={verifiedSeller ? "/questions/pending" : "#"}>
                          <div className="box">
                            <div className="icon-img"><i className="bi bi-patch-question"></i></div>
                            <div className="title">
                              <div className="name">Questions</div>
                            </div>
                            <div className="count">{PendingQuestionCount}</div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink>
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px" }}>
                        {/* <NavLink to={verifiedSeller ? "/my-enquiry" : "#"}>
                          <div className="box">
                            <div className="icon-img"><img src="/home-icon/enquires.webp" alt="enquiries" /></div>
                            <div className="title">
                              <div className="name">New Enquiries</div>
                            </div>
                            <div className="count">{noenquiry}</div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink> */}
                      </div>
                    </div>
                    {/* Customer Engagement Section ends */}

                    {/* Growth Opportunities */}
                    <div className="w-30 home-shadow-box" >
                      <div className="section-title">
                        <i className="bi bi-star" style={{ color: "limegreen", fontSize: "19px" }}></i>
                        Growth Opportunities
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px", background: "#F0FFF0" }}>
                        <NavLink to={verifiedSeller ? "/opportunities/pricing-opportunities" : "#"}>
                          <div className="box">
                            <div className="icon-img"><img src={opImg2} alt="pricing-opportunity" /></div>
                            <div className="title">
                              <div className="name">Pricing Opportunity</div>
                            </div>
                            <div className="count">{pricingOppCount}</div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink>
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px", background: "#FFE4E1" }}>
                        <NavLink to={verifiedSeller ? "/customer-leads/details" : "#"}>
                          <div className="box">
                            <div className="icon-img"><img src={opImg3} alt='new-leads' /></div>
                            <div className="title">
                              <div className="name">New Leads</div>
                            </div>
                            <div className="count">{LeadCount} </div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink>
                      </div>
                      <div className="col-lg-12 col-sm-12 col-xs-12 mb-10" style={{ padding: "0px" }}>
                        {/* <NavLink to={verifiedSeller ? "/my-enquiry" : "#"}>
                          <div className="box">
                            <div className="icon-img"><img src="/home-icon/enquires.webp" alt="enquiries" /></div>
                            <div className="title">
                              <div className="name">New Enquiries</div>
                            </div>
                            <div className="count">{noenquiry}</div>
                            <div className='chevron34'><img src="/home-icon/ep_arrow-up-bold.png" /></div>
                          </div>
                        </NavLink> */}
                      </div>
                    </div>
                    {/* Growth Opportunities ends */}

                  </Row>
                </div>
              </Row>

              {/* Recent Orders + Missed Opportunities row: 50/50 when both, full width for Recent when missed empty */}
              <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                {/* Recent Orders Section */}
                <div
                  className="recent-orders-section"
                  style={{
                    flex: missedOpportunities?.length > 0 ? '1 1 calc(50% - 10px)' : '1 1 100%',
                    minWidth: 0,
                    padding: '20px',
                    background: '#fff',
                    borderRadius: '8px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                  }}
                >
                  {recentOrders && recentOrders.length > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <div>
                      <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#333', fontFamily:'Poppins' }}>Recent Orders</h3>
                      <p style={{ margin: '5px 0 0', fontSize: '13px', color: '#666' }}>Track which sellers are winning orders</p>
                    </div>
                    <div style={{ display: 'flex', gap: '20px' }}>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '23px', fontWeight: 'bold', color: '#4CAF50' }}>{recenOrdersCat?.newOrders}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>You Won</div>
                      </div>
                      <div style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '23px', fontWeight: 'bold', color: '#FF5252' }}>{recenOrdersCat?.lostOrders}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>Lost</div>
                      </div>
                    </div>
                  </div>}

                  {/* Order Items */}
                  <div style={{ borderTop: '1px solid #e0e0e0' }}>
                    {
                      recentOrders && recentOrders.map((item, index) => {
                        let orderType = item?.orderType
                        let productName = orderType === "LOST_ORDER" ? item?.product?.productName : item?.productName
                        let price = orderType === "LOST_ORDER" ? item?.lowestPrice : item?.purchase_price
                        let orderTime = timeAgo(item?.createdAt)
                        let quantity = orderType === "LOST_ORDER" ? item?.product?.quantity : item?.quantity
                        return (
                          <div style={{ display: 'flex', alignItems: 'flex-start', padding: '15px 10px 15px 12px', borderBottom: '1px solid #e0e0e0', borderLeft: '4px solid #FF5252', background: orderType === "LOST_ORDER" ? "#FFE6E6" : "#E6FFE6" }} key={index}>
                            <div style={{ marginRight: '12px', marginTop: '2px' }}>
                              <i className="bi bi-check-circle-fill" style={{ fontSize: '24px', color: '#4CAF50' }}></i>
                            </div>
                            <div style={{ flex: 1 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '5px' }}>
                                <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '500', color: '#333' }} className='ff_Pop'>{productName} {item && renderCombination(item)}</h5>
                                {
                                  orderType === "NEW_ORDER" ? <span style={{
                                    padding: '2px 10px',
                                    borderRadius: '12px',
                                    fontSize: '11px',
                                    fontWeight: '600',
                                    background: '#E6FFE6',
                                    color: '#388E3C'
                                  }}>YOU WON</span> :
                                    orderType === "LOST_ORDER" ? <span style={{
                                      padding: '2px 10px',
                                      borderRadius: '12px',
                                      fontSize: '11px',
                                      fontWeight: '600',
                                      background: '#FFE6E6',
                                      color: '#D32F2F'
                                    }}>YOU LOST</span> : <></>
                                }
                              </div>
                              <div style={{ fontSize: '11px', color: '#666' }}>
                                <span>Winner: </span>
                                <span style={{ color: '#333', fontWeight: '500' }}>{orderType === "LOST_ORDER" ? "Other seller" : vendorName}</span>
                                <span style={{ margin: '0 10px' }}>•</span>
                                <span>Qty: {quantity}</span>
                                <span style={{ margin: '0 10px' }}>•</span>
                                <span style={{ fontWeight: '600', color: '#333' }}>₹{price}</span>
                              </div>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px', marginLeft: '12px' }}>
                              <div style={{ textAlign: 'right', fontSize: '12px', color: '#999' }}>
                                <i className="bi bi-clock" style={{ marginRight: '5px' }}></i>
                                {orderTime}
                              </div>
                              {orderType === "LOST_ORDER" && (
                                <button className='ad-pr-btn-home' onClick={() => {
                                  handleAdjustLostOrderClick(item)
                                }}>Adjust Price</button>
                              )}
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>

                {/* Missed Opportunities Section */}
                {missedOpportunities?.length > 0 && (
                  <div
                    className="missed-opportunities-section"
                    style={{
                      flex: '1 1 calc(50% - 10px)',
                      minWidth: 0,
                      padding: '20px',
                      background: '#fff',
                      borderRadius: '8px',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    }}
                  >
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div style={{ width: '36px', height: '36px', borderRadius: '8px', background: '#FFF3E0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="bi bi-graph-up-arrow" style={{ fontSize: '18px', color: '#F18805' }}></i>
                        </div>
                        <div>
                          <h3 style={{ margin: 0, fontSize: '15px', fontWeight: '600', color: '#333', fontFamily:'Poppins' }}>Missed Opportunities</h3>
                          <p style={{ margin: '5px 0 0', fontSize: '13px', color: '#666' }}>Products not in your stock but in demand.</p>
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <span style={{ fontSize: '23px', fontWeight: 'bold', color: '#333' }}>{missedOpportunities?.length}</span>
                        <span style={{ display: 'block', fontSize: '12px', color: '#666' }}>{missedOpportunities?.length > 1 ? "Opportunities":"Opportunity"}</span>
                      </div>
                    </div>

                    <div style={{ borderTop: '1px solid #e0e0e0' }}>
                      {missedOpportunities.map((item, index) => {
                        let sku = item?.product?.productId?.SKU;
                        let productName = item?.product?.productId?.productName;
                        let enquiryCount = item?.lostVendorDetails?.enquiriesReceived;
                        let orderLostCount = item?.lostVendorDetails?.orderLostStockCount;
                        let time = timeAgo(item?.lostVendorDetails?.lastUpdated || null);
                        let curPurchasePrice = item?.lostVendorDetails?.curPurchasePrice;
                        return(
                        <div
                          key={index}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '15px 10px 15px 12px',
                            borderBottom: '1px solid #e0e0e0',
                            gap: '12px',
                          }}
                        >
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <h5 style={{ margin: 0, fontSize: '12px', fontWeight: '500', color: '#333' }} className='ff_Pop'>{productName} {renderCombination(item)}</h5>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '5px', flexWrap: 'wrap' }}>
                              <span style={{ fontSize: '11px', color: '#666' }}>SKU: {sku}</span>
                              {enquiryCount > 0 && (
                                <span style={{ padding: '2px 8px', borderRadius: '12px', fontSize: '11px', background: '#E3F2FD', color: '#1976D2', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                  <i className="bi bi-chat-dots" style={{ fontSize: '10px' }}></i>
                                  {enquiryCount} enquiries
                                </span>
                              )}
                              {orderLostCount > 0 && (
                                <span style={{ padding: '2px 8px', borderRadius: '12px', fontSize: '11px', background: '#FFEBEE', color: '#D32F2F', display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
                                  <i className="bi bi-dash-circle" style={{ fontSize: '10px' }}></i>
                                  {orderLostCount} order lost
                                </span>
                              )}
                            </div>
                          </div>
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
                            <div style={{ textAlign: 'right' }}>
                              <div style={{ fontSize: '12px', color: '#999', marginBottom: '2px' }}>
                                <i className="bi bi-clock" style={{ marginRight: '5px' }}></i>
                                {time}
                              </div>
                              <div style={{ fontSize: '14px', fontWeight: '600', color: '#333', fontFamily:'sans-serif' }}>
                                ₹ {curPurchasePrice}
                              </div>
                            </div>
                            <button
                              type="button"
                              onClick={() => {
                                setSelectedMissedOpp(item);
                                setAddStockValue('');
                                setIsAddStockModalOpen(true);
                              }}
                              style={{
                                padding: '6px 14px',
                                fontSize: '12px',
                                fontWeight: '600',
                                background: '#F18805',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '6px',
                                boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                                whiteSpace: 'nowrap',
                                cursor: 'pointer'
                              }}
                            >
                              Add to Stock
                            </button>
                          </div>
                        </div>
                        )
                      }
                      )}
                    </div>
                  </div>
                )}
              </div>

            </section>
          </div>
          {/* Toast */}
          <Toast show={showToast} className="ToastHome" onClose={() => setshowToast(false)}>
            <Toast.Header>
              <strong className="me-auto">Message</strong>
            </Toast.Header>
            <Toast.Body>{ToastMsg}</Toast.Body>
          </Toast>

          {/* Modal Confirmation */}
          <Modal
            show={confirmationState}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <ConfirmationModal
              onHide={confirmationBoxHiding}
              pId={selectedProduct}
              selectedId={selectedId}
              msg={msgConfirmation}
              proresDeact={deactiveReason}
              responseconfirmationFun={responseconfirmation}
            />
          </Modal>

          {/* Modal confirmaion enquiry */}
          <Modal
            show={confirmationStateEnquiry}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
            <ConfirmationModal
              onHide={confirmationBoxHidingEnquiry}
              selectedId={selectedenquiry}
              msg={msgConfirmation}

              responseconfirmationFun={responseConfirmationEnquiry}
            />
          </Modal>
        </div>
        {/* Popup gst tan verify */}

        <Modal

          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={gsttanpopup}
          onHide={() => setgsttanpopup(false)}
        >
          <Modal.Body className='m-1 text-center'>
            <h5 className='ff_Pop'>Uploaded KYC is Invalid</h5>
            <p className='title fs-15 text-danger ff_Pop'>
              Note: - Please complete your KYC to proceed further
            </p>
            <NavLink className='text-danger' exact to="/profile"><button className='m-2 btn_verify_home_gsttan py-1 '>Resubmit</button></NavLink>
            <button className='m-2 btn_verify_home_gsttan py-1 fs-12' onClick={() => setgsttanpopup(false)}>Skip for now</button>
          </Modal.Body>

        </Modal>

        {/* Popup seller agreement */}
        <Modal
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={agreementpopup}
          onHide={() => setagreementpopup(false)}
        >
          <Modal.Body className='m-1 text-center'>
            <h5 className='ff_Pop'>Agreement document</h5>
            <p className='title fs-15 text-danger ff_Pop'>
              Note: - Please upload agreement document
            </p>
            <NavLink className='text-danger' exact to="/profile"><button className='m-2 btn_verify_home_gsttan py-1 '>Reverify</button></NavLink>
          </Modal.Body>

        </Modal>

        <NoticePopup />
        <AdjustPriceModal
          isOpen={isOpenAdjPrModal}
          onClose={onClosedAdjPrModal}
          productData={orderLostCurrentData}
          receivedFrom="Recent Order"
        />

        {/* Add to Stock Modal */}
        <Modal
          show={isAddStockModalOpen}
          size="sm"
          aria-labelledby="add-stock-modal-title"
          centered
          onHide={() => setIsAddStockModalOpen(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title id="add-stock-modal-title">Add to Stock</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ marginBottom: '15px' }}>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '8px', display: 'block' }}>
                Product: {selectedMissedOpp?.product?.productId?.productName} {renderCombination(selectedMissedOpp)}
              </label>
              <label style={{ fontSize: '13px', color: '#666', marginBottom: '12px', display: 'block' }}>
                SKU: {selectedMissedOpp?.product?.productId?.SKU}
              </label>
              <label style={{ fontSize: '14px', fontWeight: '500', color: '#333', marginBottom: '8px', display: 'block' }}>
                Enter Stock Quantity
              </label>
              <input
                type="number"
                min="1"
                value={addStockValue}
                onChange={(e) => setAddStockValue(e.target.value)}
                onWheel={(e)=>e.target.blur()}
                placeholder="Enter quantity"
                style={{
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ddd',
                  borderRadius: '6px',
                  fontSize: '14px',
                  boxSizing: 'border-box'
                }}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              onClick={() => setIsAddStockModalOpen(false)}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                fontWeight: '600',
                background: '#f0f0f0',
                color: '#333',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleStockAddForMissedOpp()
              }}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                fontWeight: '600',
                background: '#F18805',
                color: '#fff',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer'
              }}
            >
              Add Stock
            </button>
          </Modal.Footer>
        </Modal>
      </>
    )
}




export default Home;